/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import {
  getConvertedUnit,
  getNullConverted
} from '../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { ConversionType, getConvertedValue } from '../../../../../main';
interface IEnergyBreakDownBaseline {
  unit: string;
  value: number | string | null;
  energyMeasurementUnit: string;
  sourceType?: string;
}
const EnergyBreakDownBaselineComponent = (props: IEnergyBreakDownBaseline) => {
  const { value, unit, energyMeasurementUnit, sourceType } = props;

  return value === null ? (
    <>--</>
  ) : (
    <span className="score-category-meterdata-meter">
      <div className="consumptionvalue">
        {
          getConvertedValue(
            sourceType ? sourceType : ConversionType?.ELECTRICITY,
            energyMeasurementUnit,
            Number(value),
            unit
          ).Value
        }
      </div>
      {getConvertedUnit(value as number, unit)}
    </span>
  );
};

export default EnergyBreakDownBaselineComponent;
